<template>
    <div>
        <h1 class="page-title">Set my communities</h1>
        <div class="community">
            <v-container fluid>
                <v-row class="header-row">
                 <v-col cols="6" md="6" lg="4">
                    <v-select label="Domain" :items="domains_to_select" v-model="domain_id" />
                 </v-col>
                    <div class="community-search">
                        <v-text-field
                                v-model="myCommunitySearchInput"
                                label="Type community name">
                        </v-text-field>
                    </div>
                </v-row>
                <v-row>
                    <v-col class="community__item-column">
                        <v-dialog v-model="dialog" width="900" @click:outside="closeDialog">
                            <template v-slot:activator="{ on }">
                                <div class="new-item-container">
                                    <div v-on="on">
                                        <div class="clients-list__item new-item new-item--high"
                                             v-ripple>
                                            <i class="material-icons new-item__icon">add</i>
                                        </div>
                                        <h2 class="new-item__title" tooltip>Add a community</h2>
                                    </div>
                                </div>
                            </template>
                            <NewCommunity :key="newCommunity"
                                          :alert_text="alert_in_dialog_text"
                                          :namespace="selected_domain_name"
                                          :writable_namespaces="writable_namespaces"
                                          :check_name_availibility=true
                                          @confirm="addCommunity"
                                          @cancel="closeDialog"
                            />
                        </v-dialog>
                    </v-col>
                    <template v-for="(item, index) of displayedMyCommunities">
                        <v-col class="community__item-column" :key="item.id">
                            <CommunityItem
                                    class="community__item"
                                    :index="index"
                                    :community="item"
                                    :errMessage="item.errMessage"
                                    :isDialogOpened="isDialogOpened"
                                    :dateRange="dateRange"
                                    v-on:dialogOpened="openDialog()"
                                    v-on:communityDeleted="deleteCommunity($event)">
                            </CommunityItem>
                        </v-col>
                    </template>
                </v-row>
                <div class="button-row">
                    <div class="text-center">
                        <v-pagination
                                v-if="filteredMyCommunities.length"
                                color="secondary"
                                v-model="myCommunitiesPage"
                                :length="Math.ceil(filteredMyCommunities.length / myCommunitiesPerPage)"
                                :total-visible="7"
                        ></v-pagination>
                    </div>
                </div>
                <v-row class="header-row" v-if="false">
                    <v-flex class="d-flex">
                        <h2 class="page-section">Pro communities</h2>
                    </v-flex>
                    <div class="community-search">
                        <v-text-field
                                v-model="proCommunitySearchInput"
                                label="Type community name">
                        </v-text-field>
                    </div>
                </v-row>
                <v-row v-if="false">
                    <template v-for="(item) of displayedProCommunities">
                        <v-col class="community__item-column" :key="item.id">
                            <ProCommunityItem
                                    v-if="item.key.namespace === 'pro'"
                                    class="community__item"
                                    :community="item"
                                    :locked="item.access_rights === 'list'"
                                    :dateRange="dateRange"
                                    :errMessage="item.errMessage">
                            </ProCommunityItem>
                        </v-col>
                    </template>
                </v-row>
                <div class="button-row">
                    <div class="text-center">
                        <v-pagination
                                v-if="filteredProCommunities.length"
                                color="secondary"
                                v-model="proCommunitiesPage"
                                :length="Math.ceil(filteredProCommunities.length / proCommunitiesPerPage)"
                                :total-visible="7"
                        ></v-pagination>
                    </div>
                </div>
            </v-container>
        </div>
    </div>
</template>

<script>
    import VennSelect from "../components/Community/VennSelect";

    import CommunityItem from "../components/Community/CommunityItem";
    import NewCommunity from "../components/Community/NewCommunity";
    import {store} from "../store/store";
    import {uuid} from "../_utils/uuid";
    import ProCommunityItem from "../components/Community/ProCommunityItem";
    import LockedProCommunityItem from "../components/Community/LockedProCommunityItem";
    import {communityCan} from '../services/community.service';
    import CommunityService from '../services/community.service';
    import moment from "moment";

    export default {
        name: "Community",
        components: {
            LockedProCommunityItem, ProCommunityItem,
            NewCommunity, CommunityItem, VennSelect
        },
        data: () => ({
            dialog: false,
            newCommunity: 0,
            alert_in_dialog_text: "",
            dateRange: {start: null, now: null},
            myCommunitySearchInput: '',
            proCommunitySearchInput: '',
            myCommunitiesPage: 1,
            proCommunitiesPage: 1,
            evListener: null,
            windowWidth: null,
            available_domains: [],
            domain_id: null,
            domains_to_select: [],
        }),
        computed: {
            writable_namespaces: function () {
              return this.available_domains
              .filter(d => d.writable)
              .map(d => {
                return d.name;
              })
            },
            selected_domain_name: function () {
                var selected_domain = this.available_domains.find(d => {return d.id == this.domain_id});
                return selected_domain ? selected_domain.name : ""
            },
            isDialogOpened: function () {
                if (this.$route.params.dialog !== undefined) {
                    return this.$route.params.dialog || this.dialog
                } else if (this.dialog) {
                    return this.dialog
                }
            },
            communities: function () {
                return store.state.communities
            },
            myCommunities() {
                return this.communities.filter(k => k.key.namespace !== 'pro')
            },
            proCommunities() {
                return this.communities.filter(k => k.key.namespace === 'pro')
            },
            filteredMyCommunities() {
                return this.filterCommunities(this.myCommunities, 'my');
            },
            filteredProCommunities() {
                return this.filterCommunities(this.proCommunities, 'pro');
            },
            displayedMyCommunities() {
                return this.calculateDisplayedCommunities(this.filteredMyCommunities, 'my');
            },
            displayedProCommunities() {
                return this.calculateDisplayedCommunities(this.filteredProCommunities, 'pro');
            },
            myCommunitiesPerPage() {
                this.myCommunitiesPage = 1;
                this.proCommunitiesPage = 1;
                switch (true) {
                    case(this.windowWidth >= 1200):
                        return 19
                    case(this.windowWidth < 992):
                        return 7
                    case(this.windowWidth < 1200):
                        return 11;
                }
            },
            proCommunitiesPerPage() {
                return this.myCommunitiesPerPage + 1
            }
        },
        methods: {
            addCommunity(community) {
                store.dispatch('addCommunity', community)
                    .then(resp => {
                        this.closeDialog();
                    })
                    .catch(err => {
                        if (err.response) {
                            this.alert_in_dialog_text = "Creation failed: " + err.response.status + " " + JSON.stringify(err.response.data)
                        } else {
                            this.alert_in_dialog_text = "Creation failed: " + JSON.stringify(err)
                        }
                        console.log("Cought error in addCommunity")
                    });
            },
            openDialog: function () {
                this.dialog = true;
            },
            closeDialog: function () {
                this.alert_in_dialog_text = "";
                this.dialog = false;
                this.newCommunity = uuid();
            },
            deleteCommunity: function (key) {
                store.dispatch('deleteCommunity', key).then(err => {
                    if (err) {
                        this.$router.push({
                            name: 'DeleteCommunityConfirmation',
                            params: {
                                id: key.name,
                                type: 'community',
                                name: key.name,
                                returnToCompName: 'Community',
                                communityIsUsed: true
                            }
                        });
                    }
                })
            },
            set_domains_to_select: function () {
                var cs = new CommunityService();
                cs.getAvailableDomains().then(available_domains => {
                  console.log("storing available domains");
                  this.available_domains = available_domains;

                  this.domains_to_select = available_domains.filter(d => {
                    return d.writable ||
                        this.communities.filter(k => k.key.namespace == d.name).length > 0;
                  }).map(d => {
                    return {
                      "text": d.name,
                      "value": d.id,
                    }
                  })
                  if (this.domains_to_select.length > 0) {
                    this.domain_id = this.domains_to_select[0].value;
                  }
                });
            },
            formatDate(d) {
                return moment(d).format("DD/MM/YYYY")
            },
            filterCommunities(arr, type) {
                if (this[`${type}CommunitySearchInput`.length]) {
                    this[`${type}CommunitiesPage`] = 1;
                }
                const regEx = new RegExp(this[`${type}CommunitySearchInput`], 'gi')
                return arr
                    .filter(com => com.key.namespace == this.selected_domain_name)
                    .filter(com => com.key.name.match(regEx));
            },
            calculateDisplayedCommunities(arr, type) {
                const comPerPage = type !== 'pro' ? this.myCommunitiesPerPage : this.proCommunitiesPerPage
                const page = type !== 'pro' ? this.myCommunitiesPage : this.proCommunitiesPage;
                const endIndex = comPerPage * page;
                const startIndex = endIndex - comPerPage;
                return arr.slice(startIndex, endIndex);
            }
        },
        mounted() {
            store.dispatch('getCommunities').then(resp => {
                if (!resp.length) {
                    store.dispatch('setCommunities')
                }
                this.set_domains_to_select()
            })
            this.windowWidth = window.innerWidth;
            this.evListener = window.addEventListener('resize', ($e) => {
                this.windowWidth = window.innerWidth;
            })

            this.dateRange = {
                now: moment().startOf('day').toISOString(),
                start: moment().startOf('day').subtract(30, 'days').toISOString()
            }
        },
        destroyed() {
            window.removeEventListener('resize', this.evListener);
        },
        watch: {
            dialog(newVal, old) {
                if (newVal === false) {
                    this.newCommunity = uuid()
                }
            },
        },
    }
</script>

<style scoped>

</style>
